import { NavBar } from './components/NavBar/NavBar';
import { Intro } from './components/Intro';
import { Hello } from './components/Hello/Hello';
import { Purpose } from './components/Purpose/Purpose';
import { Create } from './components/Create/Create';
import { OServices } from './components/OServices/OServices';
import { Contact } from './components/Contact/Contact';
import { Copyright } from './components/Copyright/Copyright';
import { Legal } from './components/Legal/Legal';

import './App.css';

import content from './data/content.json';

function App() {
  return (
    <div className="App">
      <div>
        <NavBar
          navbar={content.NavBar}
        />
      </div>

      <div className='component-container' style={{marginTop:"30px"}}>
        <Intro
          intro={content.Intro}
        />
      </div>
      
      <Hello className='component-container'
        welcome={content.Welcome}
        experience={content.Experience}
      />

      <Purpose
        mission={content.Mission}
        vission={content.Vission} 
      />

      <Create
        apps={content.Apps}
        boost={content.Boost} 
      />

      <OServices
        oservices={content.OServices} 
      />

      <Contact
        ceo={content.CEO}
        channels={content.Channels} 
      />

      <Copyright
        copyright={content.Copyright}
      />

      <Legal 
        legal={content.Legal}
      />

    </div>
  );
}

export default App;